import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const orderByDescending = (source, keySelector, comparer) => {
    return OrderedParallelEnumerable.generate(source, keySelector, false, comparer);
};
